/**
 请求拦截器: 发送请求前的处理
**/
import store from '@/page/store';
/*
 自动在header带上token
*/
export const takeTokenHandle = config => {
  // 如果请求的接口不是/login或/register，那么是需要在header中传token
  // if (config.url.indexOf('/login') < 0 && config.url.indexOf('/register') < 0) {
  //   // 如果不存在，则自动带上
  //   if (!('token' in config.headers)) {
  //     config.headers.token = store.get('token');
  //   }
  // }
  // 只要本地存在 TOKEN，就为所有请求自动带上（登录/注册接口后端会忽略 token）
  // 学习中心等所有 @LoginRequired 接口均依赖此 header
  if (!('token' in config.headers)) {
    const token = localStorage.getItem('TOKEN');
    if (token) {
      config.headers.token = token;
    }
  }

  return config;
};

/*
 忽略post, put参数值为undefined, null, ''的参数
*/
export const ignoreViolationParamsHandle = config => {
  if (config.method.toLowerCase() !== 'get' && config.data) {
    const isFormdata = config.data instanceof FormData;
    const memo = isFormdata ? new FormData : {};

    if (isFormdata) {
      for (let key of config.data.keys()) {
        if (config.data.get(key) !== void 0 && config.data.get(key) !== '')
        memo.append(key, config.data.get(key));
      }
    } else {
      Object
        .keys(config.data)
        .filter(key => config.data[ key ] !== void 0 && config.data[ key ] !== '')
        .reduce((mo, key) => {
          mo[ key ] = config.data[ key ];
          return mo;
        }, memo);
    }
    config.data = memo;
  }
  return config;
};

/*
 所有非get并且content-type为json的字符串字段去除首尾空白字符
 */
export const trimHandle = config => {
  if (config.method.toLowerCase() !== 'get' && config.data && config.headers[ 'Content-Type' ].indexOf('json') > 0) {
    const body = config.data;
    config.data = Object.keys(body).reduce((memo, key) => {
      if (typeof body[ key ] === 'string') {
        memo[ key ] = body[ key ].trim();
      } else {
        memo[ key ] = body[ key ];
      }

      return memo;
    }, {});
  }

  return config;
};
